"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PastOrder = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _formatters = require("formatters");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp, _class3, _descriptor9, _temp2;

var PastOrderPage = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(PastOrderPage, _Component2);

  function PastOrderPage() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, PastOrderPage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(PastOrderPage)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(PastOrderPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement("div", {
        "data-cart-page": "true"
      }, _react.default.createElement("div", null, _react.default.createElement(PastOrder, this.content))));
    }
  }]);
  return PastOrderPage;
}(_react.Component), _temp2), (_descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = PastOrderPage;
var PastOrder = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PastOrder, _Component);

  function PastOrder() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PastOrder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PastOrder)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "clientName", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderDate", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "orderNumber", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "submittedBy", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "poRefNumber", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "items", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "comment", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(PastOrder, [{
    key: "reorder",
    value: function reorder() {
      (0, _fetch.default)("data/cart/reorder", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          order: this.id
        })
      }).then(function (data) {
        return data.json();
      }).then(function (d) {
        _SiteLayout.default.current.navigate(d.target);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "orderReviewHeader"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, _react.default.createElement("div", {
        className: "order-review-header"
      }, _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "details-container"
      }, _react.default.createElement("p", null, this.clientName), _react.default.createElement("h1", null, new Date(this.orderDate).format('F j, Y')), _react.default.createElement("p", {
        className: "date-person"
      }, "Order #", this.orderNumber, " - Submitted by ", this.submittedBy, this.poRefNumber ? " - P.O. ".concat(this.poRefNumber) : ''), _react.default.createElement("a", {
        className: "btn btn-primary reorder",
        href: "javascript:void(0)",
        onClick: this.reorder
      }, "Re-Order")), _react.default.createElement("div", {
        className: "price-container"
      }, _react.default.createElement("h3", null, "Order Total"), _react.default.createElement("h3", {
        className: "price"
      }, (0, _formatters.formatPrice)(this.items.map(function (item) {
        return item.quantity * item.price;
      }).reduce(function (a, b) {
        return a + b;
      }), true))))))), _react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "orderReview"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, _react.default.createElement(_Cart.default, {
        contents: this.items,
        mode: "PreviousOrder",
        previousOrder: {
          id: this.id,
          comment: this.comment
        }
      }))));
    }
  }]);
  return PastOrder;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "clientName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderDate", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "submittedBy", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "poRefNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "items", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "comment", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "reorder", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "reorder"), _class.prototype)), _class);
exports.PastOrder = PastOrder;